import { Component, inject, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { IRequiredReportFields } from '../interfaces/irequired-report-fields';
import { IReportSearch } from '../interfaces/ireport-search';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { ReportService } from '@core/services/report.service';
import { TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs';

@Component({
    selector: 'drdp-state-cohort',
    templateUrl: './state-cohort.component.html',
    styleUrls: ['./state-cohort.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StateCohortComponent implements OnInit {
  requiredFields: IRequiredReportFields = {
    state: true,
    agency: false,
    globalRatingPeriod: true,
    site: false,
    classroom: false,
    ageGroup: true,
    requireMultipleRatingPeriods: true,
    requireRpInSameSchoolYear: false
  };

  dialog = inject(MatDialog);
  reportService = inject(ReportService);
  private translocoService = inject(TranslocoService);
  route = inject(ActivatedRoute);
  is2025: boolean = false;
  title: string = '';

  ngOnInit(): void {
    this.is2025 = this.route.snapshot.data['is2025'] ?? false;
    this.title = this.translocoService.translate('reports.stateCohort.title', { year: this.is2025 ? '2025' : '2015' });
  }

  showReport(searchValue: IReportSearch): void {
    const service = (payload: IReportSearch) => this.is2025
      ? this.reportService.saveStateCohortRequest2025(payload)
      : this.reportService.saveStateCohortRequest(payload);

    service(searchValue)
      .pipe(take(1))
      .subscribe((res: boolean) => {
        if (res) this.displaySuccessMessage();
      });
  }

  displaySuccessMessage(): void {
    const modal = {
      data: {
        modalInfo: {
          title: this.translocoService.translate('reports.requestSubmitted.title'),
          message: this.translocoService.translate('reports.requestSubmitted.message'),
          primaryBtnClass: 'blue',
          primaryBtnText: this.translocoService.translate('reports.requestSubmitted.confirm'),
          showCancel: false,
        },
      },
    };
    this.dialog.open(ConfirmationModalComponent, { data: modal });
  }
}
